/**
 * Hover animations
 *
 * @param {}
 * @return {void}
 */

const $element = $('.js-hover');
let pageX = 0;
let pageY = 0;

const animateElement = (element) => {
  const $this = element;
  const $elementInner = $this.find('.js-hover-inner');
  let elemOffset = $this.offset();
  let relX = pageX - elemOffset.left;
  let relY = pageY - elemOffset.top;

  if ($this.closest('.flickity-viewport.is-pointer-down').length) {
    return;
  }

  if ($elementInner.length) {
    $elementInner.css({
      'top': (relY - 40) + 'px',
      'left': (relX - 40) + 'px'
    });
  }
}

$(document).on('mousemove', function(e){
  pageX = e.pageX;
  pageY = e.pageY;
});

$(document).on('mouseenter', '.js-hover', function(event) {
  animateElement($(this))
});

$(document).on('mouseleave', '.js-hover', function(event) {
  animateElement($(this))
});

$(document).on('touchstart', '.js-hover', function(e) {
  pageX = e.originalEvent.touches[0].pageX;
  pageY = e.originalEvent.touches[0].pageY;

  const $this = $(this);
  const $elementInner = $this.find('.js-hover-inner');
  let elemOffset = $this.offset();
  let relX = pageX - elemOffset.left;
  let relY = pageY - elemOffset.top;

  if ($elementInner.length) {
    $elementInner.css({
      'top': (relY - 40) + 'px',
      'left': (relX - 40) + 'px'
    });
  }
});
